import React from 'react';
import { Table } from 'antd';
import { TABLE_COLUMNS, TABLE_DATA } from '../../constants/Constants';
import './DetailViewTable.css';

const DetailViewTable = ({ tableData, role }) => {
  console.log(tableData);
  
  let columns = [...TABLE_COLUMNS];
  if (role === "System Admin") {
    columns = [
      { 
        title: "Supplier Name",
        dataIndex: "companyName",
        key: "supplier",
        align: "left",
      },
      {
        title: "Rank",
        dataIndex: "rank",
        key: "rank",
        align: "left",
      },
      ...columns
    ];
  }
  
  console.log(columns);
  
  return (
    <div className="custom-table-container m-2">
      <Table 
        columns={columns} 
        dataSource={tableData} 
        pagination={false}
        scroll={{ x: "max-content" }}
        rowKey="responseId"
      />
    </div>
  );
};

export default DetailViewTable;
